import { createDirectus, rest, realtime, authentication, withToken, readItem, readItems } from '@directus/sdk';

const DIRECTUS_URL = process.env.REACT_APP_DIRECTUS_URL || 'http://localhost:8055';

// REST client for content/live preview
const client = createDirectus(DIRECTUS_URL)
  .with(rest({ credentials: 'include' }));

// Realtime client for chat (separate instance to avoid auth conflicts)
const realtimeClient = createDirectus(DIRECTUS_URL)
  .with(authentication())
  .with(realtime());

export { client, realtimeClient, withToken, readItem, readItems };
export default client;
